import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/order',
  component: Layout,
  name: 'orderManagement',
  meta: {
    title: '订单管理',
    icon: 'i-ep:shopping-cart',
    menu: false,
  },
  children: [
    {
      path: 'list',
      name: 'orderList',
      component: () => import('@/views/order/index.vue'),
      meta: {
        title: '订单列表',
        icon: 'i-ep:shopping-cart',
      },
    },
    {
      path: 'detail/:id',
      name: 'orderDetail',
      component: () => import('@/views/order/detail.vue'),
      meta: {
        title: '订单详情',
        icon: 'i-ep:document',
        menu: false,
      },
    },
  ],
}

export default routes
